import { AccountClaimViewModel } from './../../../../../common/model/account/accountClaimViewModel';
import { createDataFetchSlice } from '../../../../utils/dataFetch';


export const accountsClaimsListSlice = createDataFetchSlice<
    AccountClaimViewModel[]
>({ name: 'list' });
